export class ContentAdvisories {
  advisoriesList: AdvisoriesItem[];

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['AdvisoriesList']) {
        this.advisoriesList = this.fillAdvisorieslist(
          contentjson['AdvisoriesList']
        );
      }
    }
  }

  private fillAdvisorieslist(contentjson?: any): AdvisoriesItem[] {
    const advisorieslist: AdvisoriesItem[] = [];
    for (const item of contentjson) {
      advisorieslist.push(new AdvisoriesItem(item));
    }
    return advisorieslist;
  }
}

export class AdvisoriesItem {
  title: any;
  Description: any;
  pageurl: any;
  timestamp: any;

  constructor(contentjson?: any) {
    if (contentjson['title']) {
      this.title = contentjson['title'];
    } else {
      this.title = '';
    }
    if (contentjson['Description']) {
      this.Description = contentjson['Description'];
    } else {
      this.Description = '';
    }
    if (contentjson['pageurl']) {
      this.pageurl = contentjson['pageurl'];
    } else {
      this.pageurl = '';
    }
    if (contentjson['timestamp']) {
      this.timestamp = contentjson['timestamp'];
    } else {
      this.timestamp = '';
    }
  }
}
